import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            专题合集
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按主题分类整理的黑料视频合集，快速找到想看的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group flex items-start gap-4 p-4 md:p-5 bg-background-100 border border-background-200/70 rounded-xl hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div
                className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${item.bgClass}`}
              >
                <i className={`${item.icon} ${item.iconClass} text-xl`} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                <div className="mt-2 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-video-line" />
                  <span>{item.count}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}